import React from "react"
import { Route, Link } from "react-router-dom"
import styled, { ThemeProvider } from "styled-components"
import { lighten } from "polished"
import PropTypes from "prop-types"
import { media } from "../../../utils/style-utils"

// Styled components for inactive nav items
const UnselectedNavItem = styled.li`
  &:hover {
    background-color: ${prop => lighten(0.25, prop.theme.navBackgroundColor)};
  }
`
const UnselectedLink = styled(Link)`
  color: #333333;
  &:hover {
    color: #ffffff !important;
  }
  ${media.desktop`font-size: 14px!important`};
`

// Styled components for the active/selected nav item
const SelectedNavItem = UnselectedNavItem.extend`
  background-color: ${prop => lighten(0.1, prop.theme.navBackgroundColor)};

  &:hover {
    background-color: ${prop => lighten(0.08, prop.theme.navBackgroundColor)};
  }

  a {
    color: #ffffff !important;
  }
`
const SelectedLink = UnselectedLink.extend``

function TopNavItem({ route, text, linkClassNames, theme }) {
  return (
    <ThemeProvider theme={theme}>
      <Route
        path={route}
        exact
        children={({ match }) =>
          match ? (
            <SelectedNavItem className="nav-item hidden-md-down">
              <SelectedLink to={route} className={linkClassNames}>
                {text}
              </SelectedLink>
            </SelectedNavItem>
          ) : (
            <UnselectedNavItem className="nav-item hidden-md-down">
              <UnselectedLink to={route} className={linkClassNames}>
                {text}
              </UnselectedLink>
            </UnselectedNavItem>
          )
        }
      />
    </ThemeProvider>
  )
}

TopNavItem.propTypes = {
  route: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  linkClassNames: PropTypes.string.isRequired,
  theme: PropTypes.shape({
    primaryColor: PropTypes.string.isRequired,
    primaryColorHover: PropTypes.string.isRequired,
    navBackgroundColor: PropTypes.string.isRequired
  }).isRequired
}

export default TopNavItem



// WEBPACK FOOTER //
// ./src/components/layout/navigation/TopNavItem.jsx